export const LocalStorageKey = {
  AUTH_TOKEN: 'authentication_token',
  EMAIL: 'email',
  REFERRAL: 'referral',
  SKYPE_MODAL_SHOWN: 'skype_modal_shown',
  OAUTH_TEMP_VERSION: 'oauth_temp_version',
};

export const SessionStorageKey = {
  DID_LOGIN: 'did_login',
  VERSION: 'version',
};
